import { resolveImage as t, resolveLink as i } from "../../../helpers/index.js";
const a = (e) => ({
  image: e.properties?.image?.[0] && t(e.properties?.image),
  button: e.properties?.link && i(e.properties?.link?.[0]),
  subject: e.properties?.subject,
  header: e.properties?.header,
  content: e.properties?.text,
  variant: e.properties?.image?.[0] ? e.properties?.picturePlacement === "right" ? "right-image" : "left-image" : void 0
});
export {
  a as spotboxDeliveryApiParser
};
